<template>
  <v-layout fill-height class="mt-1">
    <v-flex>
      <v-sheet height="80vh"
          class="overflow-hidden">
        <div>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
          />
      </div>
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="(qunits || {}).units"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          :weekdays="weekdays"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
          event-name="titulo"
          event-text-color="black"
          :max-days="31"
          :locale="$vuetify.lang.current"
        >
          <template v-slot:event="{ event }">
            <div class="pa-0 ma-1">
              <v-row >
                <v-col class="pt-0 pb-0">
                <v-row class="ma-0 pl-2 pt-1 qmkey-calendar-event">
                    <div class="qmkey-event-reference">
                      <Field 
                        :field="event.reference"
                      />
                    </div>
                  <Actions
                    v-if="!is_mobile"
                    style=""
                    size="medium"
                    :unit="event"
                    :action_list="['ActionTransitions']"
                    @update-qunit="update_qunit"
                  ></Actions>
                  </v-row>
                  <v-row class="ma-0 pl-2 pr-2" overflow="hidden">
                    <div class="qmkey-event-title mr-1 mb-1">
                      <Field
                      short
                      :field="event.title"
                    />
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          min-width="350px"
          max-width="600px"
          :auto="true"
          content-class="qmkey-calendar-content"
        >
          <Card
            :unit="selectedEvent"
            @navigate_to="navigate_to(selectedEvent)"
            @update="(filters) => update_row(props.item, filters)"
            @update-qunit="update_qunit"
            @update-qunit-at="update_qunit"
            actions
            :action_list="current_actions"
          ></Card>
        </v-menu>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
  import DynamicForm from '@/components/DynamicForm'
  import ModalDialogForm from './ModalDialog'
  import QReport from '@/api/QReportsItem'
  import QUnitCollection from '@/qunit/QUnitCollection';
  import Actions from '@/components/explorer/actions/Actions';
  import Field from '@/components/qfields/Field';
  import Card from '@/components/explorer/Card';
  import { QFilters, get_qfilter } from '@/qunit/filters';
  
  
  export default {
    name: 'ExplorerCalendar',

    props: {
      qunits: QUnitCollection,
      filters: { type: QFilters, default: () => new QFilters() },
      action_list: {
        default: () => ([
          'ActionTransitions',
          'ActionViewQUnit',
          'ActionShowContacts',
          'ActionDownloadEvidence',
          'ActionDownloadCurrent',
          'ActionViewReports',
        ])
      },
      view_props: {default: () => ({})},
      loading: Boolean,
      is_mobile: Boolean,
    },

    components: {
      DynamicForm,
      ModalDialogForm,
      Actions,
      Field,
      Card,
    },

    data: () => ({
      today: new Date().toISOString().split('T')[0],
      focus: new Date().toISOString().split('T')[0],
      type: 'month',
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      addUnitBussinessProcess: '',
      addUnitParentProcess: '',
      business_process_name: '',
      disableAdddModalButtons: false,
      disableTransitionModalButtons: false,
      creation_fields_to_collect: [],
      creation_form_error_message: '',
      fields_to_collect: [],
      show_transitions: true,
      current_transition: {},
      alert: '',
      showModalDialog: false,
      valid: null,
      showAddModalDialog: false,
      modal_title: '',
      submit_button_caption: '',
    }),
  
    computed: {
      monthFormatter() {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC',
          month: 'long',
        })
      },
      ...mapGetters(['isUser', 'sitePath']),
      ...mapState([
        'isLoading',
        'message',
        'sites',
        'current_unit',
        'current_parent_process',
        'searchText',
        'allProcesses',
        'processID',  // Deprecated
        'context_title',
        'calendar_units',
        'filterDates',
        'filterFormData',
        'filterProcesses'
      ]),
  
      current_business_process() {
        // TODO: This property should come from parent component
        return this.$route.query.business_process;
      },
  
      current_lang() {
        return this.$vuetify.lang.current;
      },
      
      current_actions() {
        let actions = this.view_props.action_list || this.action_list;
        if (!actions.includes('ActionNavigate')) {
          return actions.concat('ActionNavigate');
        }
        return actions;
      },
  },

    mounted() {
      this.focus = this.filterDates[0]
        ? new Date(this.filterDates[0]).toISOString().split('T')[0]
        : new Date().toISOString().split('T')[0];
      

      this.updateProps();
    },

    destroyed() {
      this.clear_range_filter();
    },
  
    methods: {
      viewDay({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor(event) {
        return event.current_workflow_state ? event.current_workflow_state.dot_color() : event.state_color;
      },
      setToday() {
        this.focus = this.today
        // this.updateProps();
      },
      prev() {
        this.$refs.calendar.prev()
        // this.updateProps();
      },
      next() {
        this.$refs.calendar.next();
        // this.updateProps();
      },
      setType(type) {
        this.type = type;
        // this.updateProps();
      },
      setFocus(date) {
        this.focus = date
        this.updateProps();
      },
      setDays(days) {
        this.weekdays = days
      },
      showEvent({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => (this.selectedOpen = true), 10)
        }
        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }
  
        nativeEvent.stopPropagation()
      },
      updateRange({ start, end }) {
        // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
        this.start = start;
        this.end = end;
        this.updateProps();

        this.$nextTick(()=>{
          this.set_range_filter(this.start,this.end);
        })
      },
      nth(d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
      },
      getTitle() {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }
        const month = this.monthFormatter(start)
        const startMonth = month.charAt(0).toUpperCase() + month.slice(1)
        const startYear = start.year
        const startDay = start.day
  
        switch (this.type) {
          case 'month':
            return `${startMonth} de ${startYear}`
          case 'week':
          case 'day':
            return `${startDay} de ${startMonth} de ${startYear}`
        }
      },
      updateProps() {
        this.$emit('update_props', {
          'calendar_props': {
            title: this.getTitle(),
            type: this.type,
            start: this.start,
            end: this.end,
            field: this.view_props.field
          }
        });
      },
      update_qunit(new_qunit) {
        this.$emit('update-qunit', new_qunit);
        this.selectedOpen = false;
      },
  
      ...mapActions(['EXPLORE_UNITS_CALENDAR']),
  
  
      toggle_dialog() {
        this.addUnitBussinessProcess = ''
        this.addUnitParentProcess = ''
        this.fields_to_collect = []
        this.creation_fields_to_collect = []
        this.showModalDialog = false
        this.addModalDialog = null
      },
      qunit_clicked() {
        this.$emit('navigate_to', this.selectedEvent);
      },

      clear_range_filter() {
        let clear_range = new QFilters();
        clear_range.delete_filter('filter_dates')
        this.update_filters(clear_range);
      },

      set_range_filter(start,end) {
        let filters = new QFilters();
        //filters.date_range = [start.date, end.date];
        filters.set_filter(get_qfilter('filter_dates', {
          range: [start.date, end.date],
          field: this.view_props.field || 'current_workflow_limit',
        }));
        this.update_filters(filters);

      },

      update_filters(filters) {
        this.$emit('update_filters',filters);
      }
    },
    watch: {
      view_props(after,before) {
        if (this.view_props && this.view_props.calendar_action) {
          this[this.view_props.calendar_action.action](...this.view_props.calendar_action.args);
          this.view_props.calendar_action = null;
        } else if (before.field != after.field) {
          this.updateRange({'start': this.view_props.start,'end': this.view_props.end});
        }
        
      },
      current_lang() {
      this.$nextTick(()=> {
        this.updateProps();
      });
    }
  },
  }
</script>

<style lang="scss">
  @import "@/sass/explorer.scss";
  .center-col-content {
    align-items: center;
    justify-content: end;
  }
  .qmkey-calendar-content{
    max-height: fit-content !important;
    overflow-y: hidden !important;
  }
  .qmkey-calendar-event {
    justify-content:space-between;
  }
</style>
